<template>
<div class="steps">
  <div v-for="(step, index) in steps" :key="step.title"   class="step-group">
    <div v-if="(index % 2) == 1 && (mobileBreakpointPx < $vssWidth)" class="columns is-vcentered">
      <div  :id="'stepDescription' + index" :data-index="index"  :ref="'stepDescription' + index" :class="{'step-description' : true, column: true, hidden: !descriptionsVisible[index], 'animate__bounceInLeft': descriptionsVisible[index], 'animate__animated': descriptionsVisible[index]}">
        <div  class="box  py-6" >
          <div v-html="step.description"/>
        </div>
      </div>
      <div  class="column">
        <div v-view="inViewHandlerDescription" :id="'step' + index" :data-index="index" class="box card step-title"  :ref="'step' + index">
          <div  class="p-3" >
            <div v-html="step.title"/>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="columns is-vcentered step-group">
      <div class="column">
        <div v-view="inViewHandlerDescription" :id="'step' + index" :data-index="index" class="box card step-title"  :ref="'step' + index">
          <div  class="p-3">
            <div v-html="step.title"/>
          </div>
        </div>
      </div>
      <div :id="'stepDescription' + index"  :ref="'stepDescription' + index" :data-index="index"  :class="{'step-description' : true, column: true, hidden: !descriptionsVisible[index], 'animate__bounceInRight': descriptionsVisible[index], 'animate__animated': descriptionsVisible[index]}">
        <div class="box py-6">
          <div v-html="step.description"/>
        </div>
      </div>
    </div>
    
    
  </div>
</div>
</template>

<script>
const LeaderLine = window.LeaderLine;
import VueScreenSize from 'vue-screen-size'
        
        
export default {
    name: 'VisProcess',
    mixins: [VueScreenSize.VueScreenSizeMixin],
    props: {
        steps: {
            Array,
            default: () => ([])
        },
        mobileBreakpointPx: {
            Number,
            default: 769
        }
    },
    data: function(){
        return {
            lines: {},
            descriptionsVisible: {}
            
        };
    },
    methods: {
        inViewHandlerDescription(e) {
            if (e.percentInView > 0.9) {
                let index = e.target.element.dataset.index;
                if (this.lines[index] == undefined && index > 0) {
                    this.animateDescription(index);
                    this.drawLine(index);
                }
                if (index == 0) {
                    this.animateDescription(index);
                }
            }
        },
        drawLine(stepIndex) {
            let start = this.$refs["step" + (stepIndex - 1)][0];
            let end = this.$refs["step" + (stepIndex)][0];
            let line = new LeaderLine(start, end, {color: '#d2032c', startSocket: 'bottom', endSocket: 'top', hide: true});
            line.show("draw");
            this.lines[stepIndex] = line;
        },
        animateDescription(stepIndex) {
            this.$set(this.descriptionsVisible, stepIndex, true);
        },
        reposition() {
            this.$nextTick(function () {
                for (let line of Object.values(this.lines)) {
                    line.position();
                }
            });
        }
        

        
    },
    mounted: function (){
        this.$on(this.$vssEvent, this.reposition);
    },
    updated: function(){
        this.reposition();
    }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .hidden {
  visibility: hidden;
  }

  .step-group {
     padding-bottom:10em;
  }

  .step-group:last-child {
     padding-bottom:1em;
  }

  
</style>
